import type { NotificationDto, NotificationListQuery, UnreadCountDto } from '@solar/types';

import { api, type QueryParams } from '@/lib/api-client';

export const notificationsService = {
  list: (params: NotificationListQuery, signal?: AbortSignal) =>
    api.list<NotificationDto>('/notifications', params as QueryParams, signal),

  unreadCount: () => api.get<UnreadCountDto>('/notifications/unread-count'),

  /** Omitting `ids` marks every unread notification as read. */
  markRead: (ids?: string[]) => api.post<{ updated: number }>('/notifications/mark-read', { ids }),

  markUnread: (ids: string[]) =>
    api.post<{ updated: number }>('/notifications/mark-unread', { ids }),

  remove: (id: string) => api.delete(`/notifications/${id}`),

  clearRead: () => api.delete<{ deleted: number }>('/notifications/read'),
};
